// extracted by mini-css-extract-plugin
export default {"modal":"st","topline":"tt","img":"ut","textcontents":"vt","heading":"wt","copy":"xt","link":"yt","close":"zt","modalinner":"At","container":"Bt"};
    if(module.hot) {
      // 1714422952849
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  